import { render, staticRenderFns } from "./CompMstContent.vue?vue&type=template&id=139ca2fb&"
import script from "./CompMstContent.vue?vue&type=script&lang=js&"
export * from "./CompMstContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports